function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6665 3.33329V16.6666H3.33317V3.33329H16.6665ZM16.6665 1.66663H3.33317C2.4165 1.66663 1.6665 2.41663 1.6665 3.33329V16.6666C1.6665 17.5833 2.4165 18.3333 3.33317 18.3333H16.6665C17.5832 18.3333 18.3332 17.5833 18.3332 16.6666V3.33329C18.3332 2.41663 17.5832 1.66663 16.6665 1.66663ZM13.7498 8.89163V7.49996C13.7498 6.58329 12.9998 5.83329 12.0832 5.83329H7.9165C6.99984 5.83329 6.24984 6.58329 6.24984 7.49996V8.89163C5.5165 9.18329 4.99984 9.89163 4.99984 10.725V14.1666H6.24984V12.9166H13.7498V14.1666H14.9998V10.725C14.9998 9.89163 14.4832 9.18329 13.7498 8.89163V8.89163ZM12.4998 7.08329V8.74996H7.49984V7.08329H12.4998ZM6.24984 10.725C6.24984 10.325 6.57484 9.99996 6.97484 9.99996H13.0332C13.4332 9.99996 13.7582 10.325 13.7582 10.725V11.6666H6.25817V10.725H6.24984Z",
  fill: "#424242"
});

var SvgBedOutlined = function SvgBedOutlined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBedOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bed-outlined.19b43574.svg";
export { ForwardRef as ReactComponent };